import { render, staticRenderFns } from "./PromotionTypes.vue?vue&type=template&id=78e5ff13"
import script from "./PromotionTypes.vue?vue&type=script&lang=js"
export * from "./PromotionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports